export const Login = ()=>{
    return (
        <div>
            <h1>Hello From The Login Page</h1>
        </div>
    )
}